import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { AuthStatusService } from '../../../services/auth-status.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginDTO } from '../../../DTO/loginDTO';
import { ExpertService } from 'src/app/services/expert.service';
import { UserService } from 'src/app/services/user.service';
import * as env from '../../../../environments/environment';
import { OperationService } from 'src/app/services/operation.service';
import { Operation } from 'src/app/models/operation.schema';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    loginDTO: LoginDTO;

    constructor(
        private authService: AuthService,
        private authStatusService: AuthStatusService,
        private router: Router,
        private _snackBar: MatSnackBar,
        private expertService: ExpertService,
        private userService: UserService,
        private operationService: OperationService,
    ) {
        this.loginDTO = new LoginDTO();
    }

    ngOnInit() {
        /*
        if (this.authStatusService.isAuthenticated)
            this.router.navigate(['/']);
        */
    }

    async login() {
        try {
            this.authService.login(this.loginDTO).then((data: any) => {
                const result: { 
                    accessToken: string, 
                    refreshToken: string, 
                    userType: string, 
                    extraId: number 
                } = data;

                if (result.accessToken) {
                    this.authStatusService.setRefreshStorage(result.refreshToken);
                    this.authStatusService.setAccessStorage(result.accessToken);

                    this.userService.getMyInformation().then(userInfo => {
                        delete userInfo.qontoAccessToken;
                        delete userInfo.qontoRefreshToken;
                        sessionStorage.setItem('currentUser', JSON.stringify(userInfo));
                    });

                    this._snackBar.open(
                        'Login avvenuto con successo. Reindirizzamento...',
                        'Chiudi',
                        {
                            direction: "ltr",
                            duration: 2000,
                            horizontalPosition: "center",
                            politeness: "assertive",
                            verticalPosition: "top"
                        }).afterDismissed().subscribe(async (resulttt) => {
                            // this.router.navigate(['/']);
                            // this.user = await this.userService.getMyInformation();
                            // sessionStorage.setItem("currentUser", JSON.stringify(this.user));
                            let user = sessionStorage.getItem('currentUser');
                            if (user) {
                                try {
                                    let parsedUser = JSON.parse(user);
                                    if (parsedUser && parsedUser.id) {
                                        if (navigator.serviceWorker) {
                                            navigator.serviceWorker.ready.then((registration) => {
                                                registration.active?.postMessage({
                                                    type: 'SET_USER_ID',
                                                    userId: parsedUser.id
                                                });
                                                registration.active?.postMessage({
                                                    type: 'SET_API_URL',
                                                    apiUrl: env.environment.url
                                                });
                                                // console.log('User ID sent to service worker:');
                                            });
                                        }
                                    }
                                } catch (error) {
                                    console.error('Error parsing user from sessionStorage:', error);
                                }
                            } else {
                                console.error('No user data in sessionStorage');
                            }

                            const redirectUrl = this.authStatusService.redirectUrl;
                            this.authStatusService.redirectUrl = null;

                            if (redirectUrl) {
                                this.router.navigateByUrl(redirectUrl);
                                return;
                            }

                            if (result.extraId && result.userType.toLowerCase() === 'expert') {
                                const loggedInExpert = await this.expertService.getOne(result.extraId);
                                this.router.navigate([loggedInExpert.isTeamLeader ? '/' : '/activities/own']);
                            } if (result.extraId && result.userType.toLowerCase() === 'operation') {
                                const loggedInExpert: Operation = await this.operationService.getOne(result.extraId);
                                this.router.navigate([!loggedInExpert.isProjectManager ? '/' : '/prodotti']);
                            } 
                            else {
                                this.router.navigate(['/']);
                            }
                            
                        });
                }

            }).catch(error => {
                const result: { statusCode: number, message: string } = error.error;
                let message: string = "";
                switch (result.message) {
                    case 'LOGIN.EMAIL_AND_PASSWORD_REQUIRED':
                        message = "Inserire email e password per poter accedere.";
                        break;
                    case 'LOGIN.USER_NOT_ACTIVE':
                        message = "Utente non attivo. Controllare l'email di attivazione.";
                        break;
                    case 'LOGIN.USER_DISABLED':
                        message = "Utente disattivato. Contattare l'amministratore per ulteriori informazioni.";
                        break;
                    case 'LOGIN.WRONG_USERNAME_OR_PASSWORD':
                        message = "Utente o password non corretti.";
                        break;
                    case 'LOGIN.GROUP_NOT_ASSIGNED':
                        // message = "L'utente non appartiene a nessun gruppo. Impossibile continuare con il login.";
                        message = "Grazie per esserti registrato a Deluxy, il tuo profilo è ora in attesa di approvazione, prova a loggarti più tardi.";
                        break;
                    default:
                        message = "Errore di sistema. Contattare l'amministratore.";
                        break;
                }
                if (message)
                    this._snackBar.open(message, 'Chiudi', {
                        direction: "ltr",
                        duration: 2000,
                        horizontalPosition: "center",
                        politeness: "assertive",
                        verticalPosition: "top"
                    });
            });
        } catch (error) {
            console.log('Server error')
        }
    }
}
